import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { Scope } from '@utils'

type AnswerRequestedContacts = 'CONFIRM' | 'DECLINE'

export interface AnswerRequestedContactsParams {
  requestedContactId: string
  answer: AnswerRequestedContacts
  scope?: Scope
}

const answerRequestedContacts = async ({
  requestedContactId,
  answer,
  scope,
}: AnswerRequestedContactsParams): Promise<undefined> => {
  const endpoint = `/contact-requests/${requestedContactId}/answer`
  const { data: responseData } = await api.post<undefined>(endpoint, {
    response: answer,
    scope,
  })
  return responseData
}

export const useAnswerRequestedContacts = () => {
  const queryClient = useQueryClient()

  return useMutation<undefined, Error, AnswerRequestedContactsParams>({
    mutationFn: answerRequestedContacts,
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ['contacts-requested-received'],
        }),
        queryClient.invalidateQueries({
          queryKey: ['contact-requests'],
        }),
        queryClient.invalidateQueries({
          queryKey: ['contacts-' + Scope.PRIVATE],
        }),
        queryClient.invalidateQueries({
          queryKey: ['contacts-' + Scope.PROFESSIONAL],
        }),
        queryClient.invalidateQueries({
          queryKey: ['contacts-suggested'],
        }),
        queryClient.invalidateQueries({
          queryKey: ['notifications'],
        }),
      ])
    },
  })
}
